export default __webpack_public_path__ + "static/media/logo-002.56e50278.png";